import { EsoService } from './../../eso.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ProductsContainerDto, SourcingDto } from '../../eso.service';
import { EsoNetworkDeepDiveProductsGroupComponent } from '../eso-network-deep-dive-products-group/eso-network-deep-dive-products-group.component';
import { NetworkDeepDiveComponent } from '../network-deep-dive.component';
import { CounterGroups } from 'src/app/services/loading-indication.service';


@Component({
	selector: "app-eso-network-deep-dive-product",
	templateUrl: "./eso-network-deep-dive-product.component.html",
	styleUrls: [
		"./eso-network-deep-dive-product.component.scss",
		"../network-deep-dive.component.scss",
	],
	standalone: false
})
export class EsoNetworkDeepDiveProductComponent {

	@Input()
	public pageComponent: NetworkDeepDiveComponent;

	@Input()
	public sourcingData: ProductsContainerDto;

	@Input()
	public sourcingDto: SourcingDto;

	@Input()
	public selected: boolean;

	@Input()
	public productsGroupComponent: EsoNetworkDeepDiveProductsGroupComponent;

	@ViewChild("tooltipButton", { static: false })
	public tooltipButton: ElementRef;

	@ViewChild("tooltipText", { static: false })
	public tooltipText: ElementRef;

	@Input()
	public decimalPipeExpression: string;

	public productDetailsColumns: { columnName: string; caption: string }[] = [];
	public productDetailsData: any[] = [];
	public productDetailsDataLoading: boolean = false;

	public initializeProductDetails(): void {
		this.productDetailsDataLoading = true;

		this._esoService.getEsoNetworkDeepDiveProductDetails(
			this.sourcingDto.mappedSourcing.esoObjectId,
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: this.sourcingDto.mappedSourcing.esoObjectId.toString()
			}
		).subscribe(
			(response) => {
				this.productDetailsColumns = response.columns;
				this.productDetailsData = response.data;
				this.productDetailsDataLoading = false;
			}
		);

	}

	constructor(
		private _esoService: EsoService,
	) {}

	public chooseProduct(evt: Event, code: any) {
		// Check if the click originated from the child button.
		const target = evt.target as HTMLElement;
		if (target.closest('dx-button')) {
			// Do nothing if the child button was clicked.
			return;
		}

		return this.pageComponent.selectProduct(code);
	}
}
